import { useState, useEffect } from 'react';
import { reaction } from 'mobx'; // 导入 reaction
// import planeicon from '@/assets/planeicon.png';
import copy from '@/assets/copy.png';
import fxtg from '@/assets/fxtg.png';
import fxx from '@/assets/fxx.png';
import u from '@/assets/u.png';
import start from '@/assets/start.png';
import card from '@/assets/card.png';
import ticket from '@/assets/ticket.png';
import invitelink from '@/assets/invitelink.png';
import userStore from '@/utils/userStore';
import { shortenedString } from '@/utils/fn/shortenedString';
import { getShareLink } from '@/utils/fn/getShareLink';
import Nodata from '@/components/Nodata';
import ProModal from '@/components/ProModal/ProModal';
import './account.css'

function Account() {
    if (!userStore.user) {
        return <Nodata />;
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [inviteUrl] = useState(`${import.meta.env.VITE_APP_URL}spin?invite_code=${userStore.user.id}`);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [copySuccess, setCopySuccess] = useState(false); // 用于存储复制状态
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [points, setPoints] = useState(userStore.point);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [usdt, setUsdt] = useState(userStore.usdt);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [credit, setCredit] = useState(userStore.credit);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [showModal, setShowModal] = useState(false);


    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        // 使用 MobX 的 reaction 监听 userStore 的变化
        const disposerPoints = reaction(
            () => userStore.point,  // 监听的 observable 属性
            (point) => {
                setPoints(point);  // 更新本地状态
            }
        );

        const disposerUsdt = reaction(
            () => userStore.usdt,
            (usdt) => {
                setUsdt(usdt);
            }
        );

        const disposerCredit = reaction(
            () => userStore.credit,
            (credit) => {
                setCredit(credit);
            }
        );

        return () => {
            disposerPoints();
            disposerUsdt();
            disposerCredit();
        };
    }, []);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(inviteUrl); // 复制到剪贴板
            setCopySuccess(true); // 设置成功状态
            setTimeout(() => setCopySuccess(false), 1000); // 2秒后清除成功状态
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    const inviteClick = () => {
        const name = 'invite';
        const category = 'user_action';
        getShareLink(name, category, inviteUrl);
    };
    const invitexClick = async () => {
        await navigator.clipboard.writeText(inviteUrl);
        window.location.href = 'https://x.com/home';
    };
    const withClick = () => {
        setShowModal(true);
    }
    const handleModalClick = () => {
        setShowModal(false);
    };
    return (
        <div className="w-full h-full">
            <div className="flex h-[250px] flex-col items-center justify-between">
                <div className="w-24 h-24 rounded-full overflow-hidden ml-1 bg-[#778eb3] flex items-center justify-center flex-shrink-0 mt-3">
                    <div>
                        <img src={userStore.avatar} alt="" />
                    </div>
                </div>
                <div className="text-xl text-white font-semibold">
                    <p>{userStore.user.id}</p>
                </div>
                {/* <div className="min-w-0 h-9  text-white rounded-3xl inline-flex items-center justify-center p-2">
                    <img src={planeicon} alt="" className="w-10 h-10" />
                    <p className="truncate text-center">GamePlayer</p>
                </div> */}
                <div className="flex space-x-2 w-full justify-between">
                    <div className="h-[60px]  flex items-center justify-center gap-2 rounded-xl px-3 py-2">
                        <div className="flex-shrink-0">
                            <img src={start} alt="" className="w-8 h-8 object-contain" />
                        </div>
                        <div className="text-white text-base">{points}</div>
                    </div>
                    <div className="h-[60px]  flex items-center justify-center gap-2 rounded-xl px-3 py-2">
                        <div className="flex-shrink-0">
                            <img src={u} alt="" className="w-8 h-8 object-contain" />
                        </div>
                        <div className="text-white text-base">{usdt}</div>
                    </div>
                    <div className="h-[60px]  flex items-center justify-center gap-2 rounded-xl px-3 py-2">
                        <div className="flex-shrink-0">
                            <img src={ticket} alt="" className="w-8 h-8 object-contain" />
                        </div>
                        <div className="text-white text-base">{credit}</div>
                    </div>
                </div>
            </div>

            <div className="w-full h-16  mt-4 rounded-xl p-3 border border-[#2a2a38] bg-[#121222]">
                <div className="flex items-center justify-between">
                    <div className='flex items-center justify-center'>
                        <div className="w-10 h-10  rounded-full flex items-center justify-center">
                            <img src={card} className="w-7 h-7" alt="" />
                        </div>
                        <div className="text-sm text-white ml-2">
                            <p>
                                {userStore.user ? shortenedString(userStore.user.address) : 'Unbound'}
                            </p>
                        </div>
                    </div>
                    <div className="text-sm text-white" onClick={withClick}>
                        <div
                            className="w-full h-8 bg-[#2631fb] rounded-full text-sm flex items-center justify-center p-3 cursor-pointer"
                        >
                            Withdraw
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full  mt-4 rounded-xl p-3">
                <div className='flex justify-center items-center'>
                    {/* <p className="text-white mb-2">Invitation Link:</p> */}
                    <img src={invitelink} alt="" className='mb-2 w-[130px]' />
                </div>
                <p className="text-[#999999] overflow-hidden text-ellipsis whitespace-nowrap mb-4">
                    {inviteUrl}
                </p>
                <div className="flex justify-center">
                    <div className="w-[200px] flex justify-around items-center">
                        <div className='relative'>

                            {copySuccess && (
                                <div className="w-[185px] h-[54px] absolute top-[-72px] left-[-83px] mb-2 px-4 py-2 bg-[#141420] text-[#999999] text-sm rounded-lg shadow-lg flex justify-center items-center transition-all duration-500 opacity-0 animate-fadeIn shadow-white/15">
                                    Replicating Success.
                                    <div className="w-3 h-3 rotate-45 bg-[#141420] absolute left-1/2 bottom-[-5px] transform -translate-x-1/2"></div>
                                </div>
                            )}


                            <div
                                className={`w-4 h-4 rounded-full cursor-pointer `}
                                data-tip="Replicating Success."
                                onClick={handleCopy}
                            >
                                <img src={copy} alt="" />
                            </div>
                        </div>
                        <div className="w-4 h-4 rounded-full cursor-pointer" onClick={inviteClick}>
                            <img src={fxtg} alt="" />
                        </div>
                        <div className="w-4 h-4 rounded-full cursor-pointer" onClick={invitexClick}>
                            <img src={fxx} alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-full lg:mt-[7rem] mt-4 rounded-[8px] p-3 text-[#999999] border border-[#241f3a] text-sm" style={{ background: "linear-gradient(135.12deg, rgba(62, 25, 90, 0) -35.07%, rgba(153, 57, 227, 0.18) 76.12%)" }}>
                <p className="mb-1 flex items-center whitespace-nowrap">
                    <span>rewards for per invitation:{userStore.user.inv_reward}</span>
                    <img src={ticket} alt="" className="ml-1 w-6 h-6 object-contain" />
                </p>

                <p className="mb-1">
                    <span>you have invited friend to register:  <span className="text-[#51a74b]">{userStore.user.inv_user_total}</span></span>
                </p>
                <p className="mb-1 flex items-center">
                    <span>
                        receive rewards of invitation:
                        <span className="text-[#51a74b]">{userStore.user.inv_reward_total}</span>
                    </span>
                    <img src={ticket} alt="" className="ml-1 w-6 h-6 object-contain" />
                </p>
            </div>
            <ProModal
                show={showModal}
                title="Withdraw"
                mixNum={1}
                ton={Number(1)}
                onClick={handleModalClick}
                pernum={1}
            />
        </div>
    );
}

export default Account;

